import { getGenericStore } from './genericStore';

const brickFactoryDataStore = Object.create(getGenericStore());
export default brickFactoryDataStore;